// Personal libs
import { ConfigSecurityDto } from '@data/dto/config-dto';
import { defaultSecurity } from '@shared/conf/settings';

/**
 * Check username validity
 * @param username
 * @param securityObject
 * @returns
 */
export function checkUsername(
  username?: string,
  securityObject?: ConfigSecurityDto,
): boolean {
  if (!username) {
    return false;
  }

  const USERNAME_MIN =
    securityObject?.username?.min ?? defaultSecurity.username?.min ?? 0;
  const USERNAME_MAX =
    securityObject?.username?.max ?? defaultSecurity.username?.max ?? 0;

  return username.length >= USERNAME_MIN && username.length <= USERNAME_MAX;
}

/**
 * Check password validity
 * @param pass
 * @param securityObject
 * @returns
 */
export function checkPassword(
  pass?: string,
  securityObject?: ConfigSecurityDto,
): boolean {
  if (!pass) {
    return false;
  }

  const PASS_SPECIAL_CAR = securityObject?.password?.authCar
    ? securityObject.password.authCar
    : defaultSecurity.password?.authCar ?? '';
  const PASS_MIN =
    securityObject?.password?.min ?? defaultSecurity.password?.min ?? 0;
  const PASS_MAX =
    securityObject?.password?.max ?? defaultSecurity.password?.max ?? 0;

  // Variables
  let testNbCar = true;
  let testLettreMaj = false;
  let testLettreMin = false;
  let testChiffre = false;
  let testSpecial = false;

  // Premier test : minimum 8 caractères, sans espaces
  // 01/11/2009 : on autorise entre 8 et 12 caractères
  if (pass.length < PASS_MIN || pass.length > PASS_MAX) testNbCar = false;

  // Deuxième test : au moins deux lettres (minuscule et majuscule), au moins un chiffre et au moins un caractères spécial
  // Au moins une lettre majuscule
  for (let i = 0; i < pass.length; i++) {
    const c = pass.substring(i, i + 1);
    if (c >= 'A' && c <= 'Z') {
      testLettreMaj = true;
      break;
    }
  }
  // Au moins une lettre minuscule
  for (let i = 0; i < pass.length; i++) {
    const c = pass.substring(i, i + 1);
    if (c >= 'a' && c <= 'z') {
      testLettreMin = true;
      break;
    }
  }
  // Au moins un chiffre
  for (let i = 0; i < pass.length; i++) {
    const c = pass.substring(i, i + 1);
    if (c >= '0' && c <= '9') {
      testChiffre = true;
      break;
    }
  }
  // Au moins un caractère spécial
  for (let i = 0; i < pass.length; i++) {
    const c: string = pass.substring(i, i + 1);
    if (PASS_SPECIAL_CAR.indexOf(c) > -1) {
      testSpecial = true;
      break;
    }
  }

  return (
    testNbCar && testLettreMaj && testLettreMin && testChiffre && testSpecial
  );
}

/**
 * Check email validity
 * @param email
 * @returns
 */
export function checkEmail(email?: string): boolean {
  if (!email) {
    return false;
  }

  const regex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return regex.test(String(email).toLowerCase());
}
